import { render, staticRenderFns } from "./iconCart.vue?vue&type=template&id=2d538c2a&scoped=true"
import script from "./iconCart.vue?vue&type=script&lang=js"
export * from "./iconCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d538c2a",
  null
  
)

export default component.exports